import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "value"],
    _excluded2 = ["input", "meta", "validateOnMount", "helperText", "description", "FormItemProps", "isRequired", "options", "label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import useFieldApi from "@data-driven-forms/react-form-renderer/use-field-api";
import Transfer from "antd/es/transfer/index.js";
import FormGroup from '../form-group';

var DualListSelect = function DualListSelect(props) {
  var _useFieldApi = useFieldApi(props),
      _useFieldApi$input = _useFieldApi.input,
      _onChange = _useFieldApi$input.onChange,
      _useFieldApi$input$va = _useFieldApi$input.value,
      value = _useFieldApi$input$va === void 0 ? [] : _useFieldApi$input$va,
      input = _objectWithoutProperties(_useFieldApi$input, _excluded),
      meta = _useFieldApi.meta,
      validateOnMount = _useFieldApi.validateOnMount,
      helperText = _useFieldApi.helperText,
      description = _useFieldApi.description,
      FormItemProps = _useFieldApi.FormItemProps,
      isRequired = _useFieldApi.isRequired,
      _useFieldApi$options = _useFieldApi.options,
      options = _useFieldApi$options === void 0 ? [] : _useFieldApi$options,
      label = _useFieldApi.label,
      rest = _objectWithoutProperties(_useFieldApi, _excluded2);

  var dataSource = options.map(function (option) {
    return _objectSpread({
      key: option.value
    }, option);
  });
  return /*#__PURE__*/React.createElement(FormGroup, {
    label: label,
    meta: meta,
    validateOnMount: validateOnMount,
    helperText: helperText,
    description: description,
    FormItemProps: FormItemProps,
    isRequired: isRequired
  }, /*#__PURE__*/React.createElement(Transfer, _extends({}, input, {
    targetKeys: value,
    onChange: function onChange(targetKeys) {
      return _onChange(targetKeys.filter(function (key) {
        return options.find(function (_ref) {
          var value = _ref.value;
          return value === key;
        });
      }));
    } // for some reason, there was always an empty string in the targetKeys argument
    ,
    render: function render(_ref2) {
      var label = _ref2.label;
      return label;
    },
    dataSource: dataSource
  }, rest)));
};

export default DualListSelect;